bcn.inputTypeNumber = (function () {

  'use strict';

  return {
    init: function () {

      if (!Modernizr.inputtypes.number) {
        var numberInputs = document.getElementsByClassName('numeric');
        var numberInputsLength = numberInputs.length;
        var i = 0;

        for(i; i < numberInputsLength; i++) {
          inputTypeNumberPolyfill.polyfillElement(numberInputs[i]);
        }

      }

    }
  };

})();
